import React from 'react';
import InputField from 'Components/InputField/InputField';

const NameField = () => {
  return (
    <InputField placeholder='Full Name' />
  )
}

export default NameField;